import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { GeneralService } from '../../services/general.service';
import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ConfigDataService } from '../../services/config-data.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TranslatorService } from '../../services/translator.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent {
     @ViewChild('MotusResourcesModal')
     MotusResourcesModal: TemplateRef<any> | undefined;

     apiUrl:string = environment.NODE_ENV;

     username: string = '';
     loginGovUrl: string = '';
     gettingDates: boolean = false;
     routeParams: ParamMap = {} as ParamMap;
     viewPage: boolean = true;
     isLoading: boolean = false;
     motusResourcesModal: any;

     constructor (public configDataService: ConfigDataService,
          private route: ActivatedRoute,
          public generalService: GeneralService,
          public _router: Router,
          public translatorService: TranslatorService,
          public modalService: NgbModal, private cookieService: CookieService) {
     }
    
     ngOnInit(): void {
          //this will clear the userJwtCsr cookie when landing on the home page
          this.cookieService.delete('userJwtCsr', '/');
          this.cookieService.delete('userJwtCsr', '/', "." + window.location.hostname);
          
          this.routeParams = this.route.snapshot.queryParamMap;
          this.translatorService.restoreBackupLanguage();

          //check if the user is logging in from login.gov
          const isLoggingIn = this.generalService.getIsLoggingIn();
          if (isLoggingIn != null) {
               this.viewPage = false;
               const code = isLoggingIn.code;
               const state = isLoggingIn.state;
               if (code !== null && state != null) {
                    this.viewPage = false;
                    // call api to get token and redirect
                    const OIDCAuthenticationLocation = `${environment.APP_API_URL}/api/OIDCAuthentication/SignInCallback?state=${state}&code=${code}`;
                    window.location.href = OIDCAuthenticationLocation;
               }
          }
        
          // //check if the user is returning from CCP checkout (driver record request)
          // const returnFromCCP = this.generalService.getReturnFromCCP();
          // if (returnFromCCP) {
          //      this.viewPage = false;
          //      window.location.href = `${environment.APP_PSP_BASE_URL}/${returnFromCCP}`;
          // }
        
          if (isLoggingIn === null){
               //&& returnFromCCP === null) {
               // clear local storage if landing on home and not logging in, clearing old token info in browswer. 
               // Don't do this before checking for other local storage items. 
               localStorage.clear();
          }

          setTimeout(() => this.scrollToTop(), 500);
     }

     async redirectToLoginGov() {
          this.isLoading = true;
          let authCode = '';
          await this.generalService.getLoginGovUrl(authCode).toPromise().then((response: string) => {
               this.loginGovUrl = response;
          });

          window.location.href = this.loginGovUrl;
     }

     ngOnDestroy() {
          
     }

     scrollToTop() {
          window.scrollTo(0, 0);
     }

     openMotusResourcesModal() {
          this.motusResourcesModal = this.modalService.open(this.MotusResourcesModal, { 
               ariaLabelledBy: 'motusResourcesModalTitle',
               size: 'lg'
          });
     }

     closeMotusResourcesModal() {
          if (this.motusResourcesModal) {
               this.motusResourcesModal.close();
          }
     }

     downloadMotusModalAsPDF() {
          // Get the modal content
          const modalContent = document.getElementById('motusResourcesModalBody');
          const modalTitle = document.getElementById('motusResourcesModalTitle');
          
          if (!modalContent || !modalTitle) {
               console.error('Modal content not found');
               return;
          }

          // Import jsPDF
          import('jspdf').then((jsPDF: any) => {
               const pdf = new jsPDF.default('p', 'mm', 'a4');
               
               // Set up fonts and colors
               const pageWidth = 190; // A4 width minus margins
               const marginLeft = 10;
               let currentY = 10;
               
               // Add blue header
               pdf.setFillColor(28, 109, 166); // #1C6DA6
               pdf.rect(marginLeft, currentY, pageWidth, 15, 'F');
               pdf.setTextColor(255, 255, 255);
               pdf.setFontSize(16);
               pdf.setFont('helvetica', 'bold');
               pdf.text(modalTitle.textContent || 'New FMCSA Motus Rollout Resources Available', marginLeft + 5, currentY + 10);
               
               currentY += 20;
               
               // Reset text color to black for body content
               pdf.setTextColor(0, 0, 0);
               pdf.setFontSize(11);
               pdf.setFont('helvetica', 'normal');
               
               // Extract all the sections from the modal
               const sections = modalContent.querySelectorAll('div.py-3');
               
               sections.forEach((section: Element, index: number) => {
                    const heading = section.querySelector('h4');
                    const paragraphs = section.querySelectorAll('p');
                    const list = section.querySelector('ul');
                    
                    // Add heading
                    if (heading) {
                         pdf.setFont('helvetica', 'bold');
                         const headingText = heading.textContent || '';
                         const lines = pdf.splitTextToSize(headingText, pageWidth - 10);
                         pdf.text(lines, marginLeft + 5, currentY);
                         currentY += lines.length * 6 + 3; // Add extra space after heading
                    }
                    
                    // Add paragraphs with inline links
                    if (paragraphs) {
                         pdf.setFont('helvetica', 'normal');
                         paragraphs.forEach((p: Element) => {
                              // Process paragraph content including links
                              const childNodes = Array.from(p.childNodes);
                              
                              childNodes.forEach((node: ChildNode) => {
                                   if (node.nodeType === Node.TEXT_NODE) {
                                        // Regular text node
                                        const text = node.textContent?.trim();
                                        if (text) {
                                             const lines = pdf.splitTextToSize(text, pageWidth - 10);
                                             pdf.setTextColor(0, 0, 0);
                                             pdf.text(lines, marginLeft + 5, currentY);
                                             currentY += lines.length * 4; // Reduced spacing after text
                                        }
                                   } else if (node.nodeName === 'A') {
                                        // Link element
                                        const link = node as Element;
                                        const href = link.getAttribute('href');
                                        const linkText = link.textContent || '';
                                        if (href && linkText) {
                                             pdf.setTextColor(0, 0, 255);
                                             pdf.textWithLink(linkText, marginLeft + 5, currentY, { url: href });
                                             pdf.setTextColor(0, 0, 0);
                                             currentY += 1; // Minimal spacing after link
                                        }
                                   } else if (node.nodeName === 'BR') {
                                        // Line break
                                        currentY += 5;
                                   } else if (node.nodeName === 'STRONG') {
                                        // Bold text
                                        const text = node.textContent?.trim();
                                        if (text) {
                                             pdf.setFont('helvetica', 'bold');
                                             const lines = pdf.splitTextToSize(text, pageWidth - 10);
                                             pdf.text(lines, marginLeft + 5, currentY);
                                             pdf.setFont('helvetica', 'normal');
                                             currentY += lines.length * 5; // Reduced spacing
                                        }
                                   } else if (node.nodeName === 'SPAN') {
                                        // Span element - check for nested content
                                        const span = node as Element;
                                        const text = span.textContent?.trim();
                                        if (text && !span.querySelector('a')) {
                                             // Only add if it doesn't contain a link (avoid duplication)
                                             const lines = pdf.splitTextToSize(text, pageWidth - 10);
                                             pdf.text(lines, marginLeft + 5, currentY);
                                             currentY += lines.length * 5; // Reduced spacing
                                        }
                                   }
                              });
                              
                              currentY += 1; // Minimal gap after paragraph
                         });
                    }
                    
                    // Add list items
                    if (list) {
                         const items = list.querySelectorAll('li');
                         pdf.setFont('helvetica', 'normal');
                         items.forEach((li: Element) => {
                              const liText = li.textContent || '';
                              if (liText.trim()) {
                                   const lines = pdf.splitTextToSize('• ' + liText, pageWidth - 15);
                                   pdf.text(lines, marginLeft + 10, currentY);
                                   currentY += lines.length * 5 + 2;
                              }
                         });
                    }
                    
                    // Add border line between sections (except for last section)
                    if (index < sections.length - 1) {
                         pdf.setDrawColor(108, 117, 125); // #6c757d
                         pdf.line(marginLeft + 5, currentY + 2, marginLeft + pageWidth - 5, currentY + 2);
                         currentY += 8;
                    } else {
                         currentY += 5;
                    }
                    
                    // Check if we need a new page
                    if (currentY > 270) {
                         pdf.addPage();
                         currentY = 10;
                    }
               });
               
               pdf.save('FMCSA_Motus_Resources.pdf');
          }).catch((err: any) => {
               console.error('Error loading jsPDF:', err);
               alert('PDF generation library not available. Please contact support.');
          });
     }
}
